(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["国际认证服务中心-app"] = factory();
	else
		root["国际认证服务中心-app"] = factory();
})(window, function() {
return 